export enum DocumentContactType {

  // Contact was selected from the existing ones
  CONTACT = 'CONTACT',
  // Contact was entered manually as free text
  INPUT = 'INPUT',
  // Cash sale / Barverkauf
  CASH_SALE = 'CASH_SALE',
}
